import { render, staticRenderFns } from "./DialogNewPixCobranca.vue?vue&type=template&id=1a21e2ca&scoped=true"
import script from "./DialogNewPixCobranca.vue?vue&type=script&lang=js"
export * from "./DialogNewPixCobranca.vue?vue&type=script&lang=js"
import style0 from "./DialogNewPixCobranca.vue?vue&type=style&index=0&id=1a21e2ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a21e2ca",
  null
  
)

export default component.exports